/* eslint-disable max-len */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';

export default class LabelNode extends BaseNode {
    operator: string;

    constructor() {
        super();
        this.linkedFeature = 'general';
        this.name = 'Comment';
        this.icon = 'BiCommentDetail';
        this.id = 'node_label';
        this.outputs = [];
    }

    getState(settingId: string): SettingState {
        if (settingId === 'DISPLAY_NAME') {
            return SettingState.ENABLED;
        }
        return super.getState(settingId);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            return '(Empty)';
        }
        return super.getSettingValue(settingId);
    }


    getName(): string {
        return '(Empty)';
    }
}
